import { useState } from 'react';
import { FormControl, FormLabel, Box, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from 'pages/organisations/companies/v5/hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const DefaultPlan = ({ darkMode, errors, defaultPlansData }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleSelectChange = (item) => {
        updateFormData(FORM_FIELD_PATHS.DEFAULT_PLAN_ID, item?.id);
        updateFormData(FORM_FIELD_PATHS.DEFAULT_PLAN, item || null);
        updateFormData(FORM_FIELD_PATHS.DEFAULT_WHOLESALER_PLAN, item || null);
    };

    const hasError = !!errors?.defaultPlanID;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Default Plan <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.DEFAULT_PLAN_ID}
                        name={FORM_FIELD_PATHS.DEFAULT_PLAN_ID}
                        data={defaultPlansData?.defaultPlans || []}
                        isLoading={defaultPlansData?.isDefaultPlansLoading}
                        shownValue="name"
                        currentId={formData?.defaultPlanID}
                        selectedId="id"
                        placeholder="Select default wholesaler plan"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        darkMode={darkMode}
                        validate={() => {
                            if (!formData?.[FORM_FIELD_PATHS.DEFAULT_PLAN_ID]) {
                                return 'Default plan is required';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the default billing plan for this wholesaler"
                        ariaLabel="default-wholesaler-plan-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DefaultPlan;
